<template>
    <div class="userManagement_main" :class="{'cn':version == '1'}">
        <div class="userManagement_left">
            <!-- <side-bar></side-bar> -->
        </div>
        <div class="userManagement_right">
            <div class="userManagement_right_top">
                <div class="right_top_l">
                    <!-- <el-select v-model="value">
                        <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select> -->
                    <el-input :placeholder="$t('App.placeholder.text1')" v-model="keywords" @keyup.native="getUserListKeyUp($event)" class="input-with-select">
                        <i slot="suffix" class="el-input__icon el-icon-search" @click="getUserList()"></i>
                    </el-input>
                </div>
                <div class="right_top_r">
                    <div class="btn" @click="AddUser()"><img :src="img_newMaintenanceStaff"><span>{{$t('App.userManagement.text1')}}</span></div>
                </div>
            </div>
            <div class="userManagement_echarts_box">
                <div class="userManagement_title">
                    <span class="text">{{$t('App.sideBar.text13')}}</span>
                </div>
                <div class="flex_ul">
                    <div class="flex_li li1">
                        <p class="p1">{{userManage.all_hotel_count}}</p>
                        <p class="p2">{{$t('App.service.text47')}}</p>
                    </div>
                    <div class="border"></div>
                    <div class="flex_li li2">
                        <p class="p1">{{userManage.system_admin_count}}</p>
                        <p class="p2">{{$t('App.userManagement.text2')}}</p>
                    </div>
                    <div class="flex_li li3">
                        <p class="p1">{{userManage.hotel_manager_count}}</p>
                        <p class="p2">{{$t('App.userManagement.text3')}}</p>
                    </div>
                    <div class="flex_li li4">
                        <p class="p1">{{userManage.hotel_user_count}}</p>
                        <p class="p2">{{$t('App.userManagement.text4')}}</p>
                    </div>
                </div>
            </div>
            <div class="userManagement_right_main">
                <div class="main_top">
                    <div class="main_top_l">
                        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">{{$t('App.lights.text10')}}</el-checkbox>
                        <div class="btn" @click="postDelUser(checkList,'batch')">
                            <i class="iconfont icon-delete"></i>
                            <span>{{$t('App.lights.text1')}}</span>
                        </div>
                    </div>
                </div>
                <div class="main_cont">
                    <el-checkbox-group v-model="checkList" @change="handleCheckedCitiesChange">
                        <el-table
                            ref="userDataList"
                            v-loading="loading.userDataList"
                            element-loading-background="rgba(0, 0, 0, 0.5)"
                            height="100%"
                            :data="userDataList">
                            <el-table-column
                                :label="$t('App.lights.text33')"
                                :prop="'index'"
                                align="left"
                                header-align="center"
                                :width="100">
                                <template slot-scope="scope">
                                    <el-checkbox :label="scope.row.id" :key="scope.row.id">{{scope.row.webIndex}}</el-checkbox>
                                </template>
                            </el-table-column>
                            <el-table-column
                                v-for="(item) in userArr"
                                :key="'table_'+item.prop"
                                :prop="item.prop"
                                :label="item.label"
                                :align="item.align?item.align:'center'"
                                :width="item.width"
                                :show-overflow-tooltip="true"
                                :min-width="item.minWidth">
                                    <template slot-scope="scope">
                                        <div v-if="item.type != 1" class="p">{{scope.row[item.prop]}}</div>
                                        <div v-if="item.prop == 'role'" class="p">{{roleArr[scope.row[item.prop]]}}</div>
                                        <div v-if="item.prop == 'status'" class="status">
                                            <span class="pl_switch" :class="{'checked':scope.row['status'] == 0}" @click="setUserStatus(scope.row)" v-if="scope.row.role!=1"></span>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                align="center"
                                :min-width="100"
                                :label="$t('App.lights.text6')">
                                <template slot-scope="scope">
                                    <span class="btn" @click="getUserInfo(scope.row)" :title="$t('App.lights.text7')">
                                        <i class="iconfont icon-xinxi"></i>
                                    </span>
                                    <span class="btn" @click="permissionSettingsFun(scope.row)" :title="$t('App.service.text22')">
                                        <i class="iconfont icon-suo"></i>
                                    </span>
                                    <span class="btn" @click="postDelUser(scope.row)" :title="$t('App.lights.text1')">
                                        <i class="iconfont icon-delete"></i>
                                    </span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-checkbox-group>
                    <!-- <div class="pagination_box">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-size="pageSize"
                            layout="prev, pager, next"
                            :total="total">
                        </el-pagination>
                    </div> -->
                </div>
            </div>
        </div>
        <!--  -->
        <div class="personnelInformation_wrap scrollbar_style" v-show="personnelInformationTkShowbg">
            <div class="personnelInformation_wrap_bg" @click="personnelInformationTkClose()"></div>
            <div class="personnelInformation_box" :class="{'personnelInformation_tk_show':personnelInformationTkShow}">
                <div class="personnelInformation_title">
                    <span class="span1">{{$t('App.userManagement.text5')}}</span>
                    <span class="span2" @click="personnelInformationTkClose()">{{$t('App.close')}}</span>
                </div>
                <div class="form">
                    <el-upload
                        class="avatar-uploader"
                        :show-file-list="false"
                        name="file"
                        :data="imgUploadData"
                        :action="actionImgUrl"
                        :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload">
                        <img v-if="userForm.avatar" :src="userForm.avatar" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        <img class="phone_icon" src="../img/phone_icon.png" />
                    </el-upload>
                    <div class="form_item">
                        <span class="laber">{{$t('App.account')}}</span>
                        <el-input v-model="userForm.account" placeholder=""></el-input>
                    </div>
                    <div class="form_item" v-if="infoType == 'add'">
                        <span class="laber">{{$t('App.password')}}</span>
                        <el-input v-model="userForm.password" placeholder=""></el-input>
                    </div>
                    <!-- <div class="form_item">
                        <span class="laber">Account-ID</span>
                        <el-input v-model="userForm.userId" placeholder=""></el-input>
                    </div> -->
                    <div class="form_item">
                        <span class="laber">{{$t('App.phone')}}</span>
                        <el-input v-model="userForm.phone" placeholder=""></el-input>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.email')}}</span>
                        <el-input v-model="userForm.email" placeholder=""></el-input>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.company')}}</span>
                        <el-input v-model="userForm.company" placeholder=""></el-input>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.position')}}</span>
                        <el-input v-model="userForm.position" placeholder=""></el-input>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.remarks')}}</span>
                        <el-input v-model="userForm.remarks" placeholder=""></el-input>
                    </div>
                </div>
                <div class="btn_box">
                    <div class="btn" @click="postSaveUser()">{{$t('App.done')}}</div>
                </div>
            </div>
        </div>
        <div class="permissionSettings_wrap scrollbar_style" v-show="permissionSettingsTkShowbg">
            <div class="permissionSettings_wrap_bg" @click="permissionSettingsTkClose()"></div>
            <div class="permissionSettings_box" :class="{'permissionSettings_tk_show':permissionSettingsTkShow}">
                <div class="permissionSettings_title">
                    <span class="span1">{{$t('App.userManagement.text6')}}</span>
                    <span class="span2" @click="permissionSettingsTkClose()">{{$t('App.close')}}</span>
                </div>
                <div class="tree_box">
                    <div class="left">
                        <div class="t">
                            <div class="laber">{{$t('App.service.text38')}}</div>
                            <el-checkbox :indeterminate="treeLAllIndeterminate" v-model="treeLAll" @change="treeLAllChange">{{$t('App.lights.text10')}}</el-checkbox>
                        </div>
                        <div class="b1 scrollbar_style">
                            <el-checkbox-group v-model="hotelCheckList" @change="hotelCheckListChange(hotelCheckList,userPermissionList)">
                                <div v-for="item in userPermissionList" :key="item.id" class="hotel_box" :class="{'noShow':item.show}">
                                    <div class="li" @click.stop="hotelShowFun(item,item.buildList.length>0)">
                                        <el-checkbox :label="item.id" :key="item.id" :indeterminate="isIndeterminateTku[item.id]">{{item.name}}</el-checkbox>
                                        <i class="iconfont icon-xiala" v-if="item.buildList.length>0"></i>
                                    </div>
                                    <el-checkbox-group v-model="buildCheckListData[item.id]" @change="buildCheckListChange(buildCheckListData[item.id],item.id,item.buildList,item.id)">
                                        <div v-for="build in item.buildList" :key="build.id" class="build_box" :class="{'noShow':build.show}">
                                            <div class="li" @click.stop="buildShowFun(build,build.floorList.length>0)">
                                                <el-checkbox :label="build.id" :key="build.id" :indeterminate="isIndeterminateTkb[item.id+'_'+build.id]">{{build.name}}</el-checkbox>
                                                <i class="iconfont icon-xiala" v-if="build.floorList.length>0"></i>
                                            </div>
                                            <el-checkbox-group v-model="floorCheckListData[item.id+'_'+build.id]" @change="floorCheckListChange(floorCheckListData[item.id+'_'+build.id],item.id,build.id,build.floorList,item.id+'_'+build.id)">
                                                <div v-for="floor in build.floorList" :key="floor.id" class="floor_box" :class="{'noShow':floor.show}">
                                                    <div class="li" @click.stop="floorShowFun(floor,floor.roomList.length>0)">
                                                        <el-checkbox :label="floor.id" :key="floor.id" :indeterminate="isIndeterminateTkf[item.id+'_'+build.id+'_'+floor.id]">{{floor.name}}</el-checkbox>
                                                        <i class="iconfont icon-xiala" v-if="floor.roomList.length>0"></i>
                                                    </div>
                                                    <el-checkbox-group v-model="roomCheckListData[item.id+'_'+build.id+'_'+floor.id]" @change="roomCheckListChange(roomCheckListData[item.id+'_'+build.id+'_'+floor.id],item.id+'_'+build.id,floor.id,floor.roomList,item.id+'_'+build.id+'_'+floor.id)">
                                                        <div v-for="room in floor.roomList" :key="room.id" class="room_box">
                                                            <div class="li">
                                                                <el-checkbox :label="room.id" :key="room.id">{{room.number}}</el-checkbox>
                                                            </div>
                                                        </div>
                                                    </el-checkbox-group>
                                                </div>
                                            </el-checkbox-group>
                                        </div>
                                    </el-checkbox-group>
                                </div>
                            </el-checkbox-group>
                            <div class="bg_box">
                                <div v-for="item in userPermissionList" :key="item.id" class="hotel_box bg" :class="{'noShow':item.show}">
                                    <div class="li"></div>
                                    <div v-for="(build,x) in item.buildList" :key="build.id" class="build_box" :class="{'noShow':build.show}">
                                        <div class="bg"></div>
                                        <div class="bg_b" v-if="build.floorList.length>0&&!build.show&&(x<item.buildList.length-1)"></div>
                                        <div class="li"></div>
                                        <div v-for="(floor,y) in build.floorList" :key="floor.id" class="floor_box" :class="{'noShow':floor.show}">
                                            <div class="bg">
                                            </div>
                                            <div class="bg_b" v-if="floor.roomList.length>0&&!floor.show&&(y<build.floorList.length-1)"></div>
                                            <div class="li"></div>
                                            <div v-for="room in floor.roomList" :key="room.id" class="room_box">
                                                <div class="bg"></div>
                                                <div class="li"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="b2 scrollbar_style">
                            <div class="hotel_box">
                                <div class="li">
                                    <el-checkbox :indeterminate="deviceAuthAllInde" v-model="deviceAuthAll" @change="deviceAuthAllChange">{{$t('App.service.text46')}}</el-checkbox>
                                </div>
                                <el-checkbox-group v-model="deviceAuth" @change="deviceAuthChange">
                                    <div class="build_box">
                                        <div class="li" v-for="item in deviceAuthArr" :key="item.key">
                                            <el-checkbox :label="item.key" :key="item.key" >{{item.laber}}</el-checkbox>
                                        </div>
                                    </div>
                                </el-checkbox-group>
                            </div>

                            <div class="bg_box">
                                <div class="hotel_box bg">
                                    <div class="li"></div>
                                    <div class="build_box" v-for="item in deviceAuthArr" :key="item.key">
                                        <div class="bg"></div>
                                        <div class="li"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="right">
                        <div class="t">
                            <div class="laber">{{$t('App.userManagement.text7')}}</div>
                            <div class="btn" @click="treeLAllChange(false)">
                                <i class="iconfont icon-delete"></i>
                                <span>{{$t('App.delete')}}</span>
                            </div>
                        </div>
                        <div class="b1 scrollbar_style">
                            <el-checkbox-group v-model="hotelCheckListR" @change="hotelCheckListChange(hotelCheckList,userPermissionList)">
                                <div v-for="item in userPermissionListR" :key="item.id" class="hotel_box" :class="{'noShow':item.show}">
                                    <div class="li" @click.stop="hotelShowFun(item,item.buildList.length>0)">
                                        <el-checkbox :label="item.id" :key="item.id" :indeterminate="isIndeterminateTku[item.id]">{{item.name}}</el-checkbox>
                                        <i class="iconfont icon-xiala" v-if="item.buildList.length>0"></i>
                                    </div>
                                    <el-checkbox-group v-model="buildCheckListData[item.id]" @change="buildCheckListChange(buildCheckListData[item.id],item.id,item.buildList,item.id)">
                                        <div v-for="build in item.buildList" :key="build.id" class="build_box" :class="{'noShow':build.show}">
                                            <div class="li" @click.stop="buildShowFun(build,build.floorList.length>0)">
                                                <el-checkbox :label="build.id" :key="build.id" :indeterminate="isIndeterminateTkb[item.id+'_'+build.id]">{{build.name}}</el-checkbox>
                                                <i class="iconfont icon-xiala" v-if="build.floorList.length>0"></i>
                                            </div>
                                            <el-checkbox-group v-model="floorCheckListData[item.id+'_'+build.id]" @change="floorCheckListChange(floorCheckListData[item.id+'_'+build.id],item.id,build.id,build.floorList,item.id+'_'+build.id)">
                                                <div v-for="floor in build.floorList" :key="floor.id" class="floor_box" :class="{'noShow':floor.show}">
                                                    <div class="li" @click.stop="floorShowFun(floor,floor.roomList.length>0)">
                                                        <el-checkbox :label="floor.id" :key="floor.id" :indeterminate="isIndeterminateTkf[item.id+'_'+build.id+'_'+floor.id]">{{floor.name}}</el-checkbox>
                                                        <i class="iconfont icon-xiala" v-if="floor.roomList.length>0"></i>
                                                    </div>
                                                    <el-checkbox-group v-model="roomCheckListData[item.id+'_'+build.id+'_'+floor.id]" @change="roomCheckListChange(roomCheckListData[item.id+'_'+build.id+'_'+floor.id],item.id+'_'+build.id,floor.id,floor.roomList,item.id+'_'+build.id+'_'+floor.id)">
                                                        <div v-for="room in floor.roomList" :key="room.id" class="room_box">
                                                            <div class="li">
                                                                <el-checkbox :label="room.id" :key="room.id">{{room.number}}</el-checkbox>
                                                            </div>
                                                        </div>
                                                    </el-checkbox-group>
                                                </div>
                                            </el-checkbox-group>
                                        </div>
                                    </el-checkbox-group>
                                </div>
                            </el-checkbox-group>
                            <div class="bg_box">
                                <div v-for="item in userPermissionListR" :key="item.id" class="hotel_box bg" :class="{'noShow':item.show}">
                                    <div class="li"></div>
                                    <div v-for="(build,x) in item.buildList" :key="build.id" class="build_box" :class="{'noShow':build.show}">
                                        <div class="bg">
                                        </div>
                                        <div class="bg_b" v-if="build.floorList.length>0&&!build.show&&(x<item.buildList.length-1)"></div>
                                        <div class="li"></div>
                                        <div v-for="(floor,y) in build.floorList" :key="floor.id" class="floor_box" :class="{'noShow':floor.show}">
                                            <div class="bg">
                                            </div>
                                            <div class="bg_b" v-if="floor.roomList.length>0&&!floor.show&&(y<build.floorList.length-1)"></div>
                                            <div class="li"></div>
                                            <div v-for="room in floor.roomList" :key="room.id" class="room_box">
                                                <div class="bg"></div>
                                                <div class="li"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="b2 scrollbar_style">
                            <div class="hotel_box" v-if="deviceAuthArr_.length>0">
                                <div class="li">
                                    <el-checkbox :indeterminate="deviceAuthAllInde" v-model="deviceAuthAll" @change="deviceAuthAllChange">{{$t('App.service.text46')}}</el-checkbox>
                                </div>
                                <el-checkbox-group v-model="deviceAuth" @change="deviceAuthChange">
                                    <div class="build_box">
                                        <div class="li" v-for="item in deviceAuthArr_" :key="item.key">
                                            <el-checkbox :label="item.key" :key="item.key">{{item.laber}}</el-checkbox>
                                        </div>
                                    </div>
                                </el-checkbox-group>
                            </div>

                            <div class="bg_box">
                                <div class="hotel_box bg">
                                    <div class="li"></div>
                                    <div class="build_box" v-for="item in deviceAuthArr_" :key="item.key">
                                        <div class="bg"></div>
                                        <div class="li"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="btn_box">
                    <div class="btn" @click="setUserPermission()">{{$t('App.done')}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    // import sideBar from '../components/sideBar.vue'
    import { mapGetters } from 'vuex'
    import allUrl from '../api/allUrl.js'
    import base from '../api/base.js'
    export default {
        name:'userManagement',
        data () {
            return{
                // value:'Admin',
                // options:[],
                keywords:'',
                value4:'456',
                userManage:{},

                checkAll:false,
                isIndeterminate:false,
                checkList:[],

                userId:'',
                userArr:[],
                userDataList:[],
                userDataIdList:[],
                maintenanceStatusArr:['Maintenance','Repaired','No maintenance'],
                roleArr:['-','System manager','Hotel manager','Hotel users','Customer account'],

                // currentPage:1,
                // pageSize:20,
                // total:0,

                personnelInformationTkShowbg:false,
                personnelInformationTkShow:false,

                permissionSettingsTkShowbg:false,
                permissionSettingsTkShow:false,

                imageUrl:'',

                treeLAll:false,
                treeLAllIndeterminate:false,
                hotelCheckList:[],
                hotelCheckListR:[],
                buildCheckListData:{},
                buildCheckListData_:{},
                buildCheckListDataLength:[],
                floorCheckListData:{},
                floorCheckListData_:{},
                floorCheckListDataLength:[],
                roomCheckListData:{},
                roomCheckListData_:{},
                isIndeterminateTku:{},
                isIndeterminateTkb:{},
                isIndeterminateTkf:{},

                userPermissionList:[],
                userPermissionList_:[],
                userPermissionListR:[],

                infoType:'',
                userForm:{
                    user:'test1',
                    userId:'',
                    phone:'',
                    email:'',
                    password:'',
                    account:'test1',
                    position:'',
                    remarks:'',
                    avatar:'.img',
                },
                objRole:'',

                imgUploadData:{
                    username:'',
                    client_key:'',
                    token:'',
                },
                actionImgUrl:'',

                deviceAuth:[],
                deviceAuthArr:[{key:'lightAuth',laber:'Light',select:0},{key:'cirLight',laber:'Circadian Lights',select:0},{key:'sensorAuth',laber:'Sensor',select:0},{key:'airPurifierAuth',laber:'Air Purifiersr',select:0}],
                deviceAuthAllInde:false,
                deviceAuthAll:false,

                loading:{
                    userDataList:false,
                },

                img_newMaintenanceStaff:'',

            }
        },
        computed:{
            ...mapGetters({
                token:'token',
                client_key:'client_key',
                username:'username',
                version:'version',
                role:'role',

                countryId:'countryId',
                provinceId:'provinceId',
                cityId:'cityId',
                hotelId:'hotelId',
                headerIdStr:'headerIdStr',
            }),
            deviceAuthArr_(){
                let arr = [];
                for(let d of this.deviceAuthArr){
                    if(d.select == 1){
                        arr.push(d)
                    }
                }
                return arr;
            }
        },
        components:{
            // 'sideBar':sideBar
        },
        mounted(){
            this.img_newMaintenanceStaff = require('../img/newMaintenanceStaff.png');
            if(this.version == '1'){
                this.img_newMaintenanceStaff = require('../img/newMaintenanceStaff_v1.png');
            }

            this.maintenanceStatusArr = [this.$t('App.service.text16'),this.$t('App.service.text17'),this.$t('App.service.text15')];
            this.roleArr = ['-',this.$t('App.userManagement.text2'),this.$t('App.userManagement.text8'),this.$t('App.userManagement.text9'),this.$t('App.userManagement.text10')];

            this.deviceAuthArr=[{key:'lightAuth',laber:this.$t('App.dashboard.text32'),select:0},{key:'cirLight',laber:this.$t('App.dashboard.text33'),select:0},{key:'sensorAuth',laber:this.$t('App.dashboard.text34'),select:0},{key:'airPurifierAuth',laber:this.$t('App.dashboard.text35'),select:0}]

            this.$store.commit('SIDEBARSHOW',{
                sideBarShow:true,
            })
            this.userArr = [
                // {prop:'user',label:'Name',minWidth:70},
                // {prop:'userId',label:'Account-ID',minWidth:100},
                {prop:'account',label:this.$t('App.userManagement.text13'),minWidth:100},
                {prop:'phone',label:this.$t('App.userManagement.text14'),minWidth:120},
                {prop:'email',label:this.$t('App.email'),minWidth:150},
                {prop:'role',label:this.$t('App.userManagement.text15'),minWidth:100,type:1},
                // {prop:'password',label:'Password',minWidth:100},
                {prop:'status',label:this.$t('App.userManagement.text16'),minWidth:80,type:1},
            ];
            this.imgUploadData.username = this.username;
            this.imgUploadData.client_key = this.client_key;
            this.imgUploadData.token = this.token;
            this.actionImgUrl = allUrl.userManagement.updateFile;
            this.getUserList();
            this.getUserManage();
        },
        methods:{
            deviceAuthAllChange(val){
                this.deviceAuth = [];
                if(val){
                    for(let d of this.deviceAuthArr){
                        this.deviceAuth.push(d.key)
                        d.select = 1;
                    }
                }else{
                    for(let d of this.deviceAuthArr){
                        d.select = 0;
                    }
                }
                this.deviceAuthAllInde = false;
            },
            deviceAuthChange(arr){
                for(let d of this.deviceAuthArr){
                    d.select = 0;
                    for(let dd of arr){
                        if(dd == d.key){
                            d.select = 1;
                        }
                    }
                }
                this.deviceAuthAll = arr.length == this.deviceAuthArr.length;
                this.deviceAuthAllInde = arr.length>0&&arr.length<this.deviceAuthArr.length;
            },
            hotelCheckListChange(arr){
                let type = arr.length>this.userPermissionList_.length?'add':'del';
                let arr1 = arr.length>this.userPermissionList_.length?arr:this.userPermissionList_;
                let arr2 = arr.length<this.userPermissionList_.length?arr:this.userPermissionList_;
                let hotelId = '';
                for(let val of arr1){
                    if(arr2.indexOf(val) == -1){
                        hotelId = val;
                    }
                }
                console.log(arr)
                this.hotelCheckListR = JSON.parse(JSON.stringify(arr));
                this.userPermissionList_ = JSON.parse(JSON.stringify(arr));
                for(let d of this.userPermissionList){
                    if(d.id == hotelId){
                        console.log(d)
                        this.isIndeterminateTku[d.id] = false;
                        if(type == 'add'){
                            d.select = 1;
                            for(let dd of d.buildList){
                                if(this.buildCheckListData[d.id].indexOf(dd.id) == -1){
                                    this.buildCheckListData[d.id].push(dd.id)
                                    this.buildCheckListData_[d.id].push(dd.id)
                                    dd.select = 1;
                                }
                                for(let ddd of dd.floorList){
                                    if(this.floorCheckListData[d.id+'_'+dd.id].indexOf(ddd.id) == -1){
                                        this.floorCheckListData[d.id+'_'+dd.id].push(ddd.id)
                                        this.floorCheckListData_[d.id+'_'+dd.id].push(ddd.id)
                                        ddd.select = 1;
                                    }
                                    for(let dddd of ddd.roomList){
                                        dddd.select = 1;
                                        if(this.roomCheckListData[d.id+'_'+dd.id+'_'+ddd.id].indexOf(dddd.id) == -1){
                                            this.roomCheckListData[d.id+'_'+dd.id+'_'+ddd.id].push(dddd.id)
                                            this.roomCheckListData_[d.id+'_'+dd.id+'_'+ddd.id].push(dddd.id)
                                        }
                                    }
                                }
                            }
                        }else{
                            d.select = 0;
                            this.isIndeterminateTku[d.id] = false;
                            this.buildCheckListData[d.id] = [];
                            this.buildCheckListData_[d.id] = [];
                            for(let dd of d.buildList){
                                dd.select = 0;
                                this.isIndeterminateTkb[d.id+'_'+dd.id] = false;
                                this.floorCheckListData[d.id+'_'+dd.id] = [];
                                this.floorCheckListData_[d.id+'_'+dd.id] = [];
                                for(let ddd of dd.floorList){
                                    ddd.select = 0;
                                    for(let dddd of ddd.roomList){
                                        dddd.select = 0;
                                    }
                                    this.isIndeterminateTkf[d.id+'_'+dd.id+'_'+ddd.id] = false;
                                    this.roomCheckListData[d.id+'_'+dd.id+'_'+ddd.id] = [];
                                    this.roomCheckListData_[d.id+'_'+dd.id+'_'+ddd.id] = [];
                                }
                            }
                        }
                    }
                    if(hotelId == ''){
                        d.select = 0;
                        this.isIndeterminateTku[d.id] = false;
                        this.buildCheckListData[d.id] = [];
                        this.buildCheckListData_[d.id] = [];
                        for(let dd of d.buildList){
                            dd.select = 0;
                            this.isIndeterminateTkb[d.id+'_'+dd.id] = false;
                            this.floorCheckListData[d.id+'_'+dd.id] = [];
                            this.floorCheckListData_[d.id+'_'+dd.id] = [];
                            for(let ddd of dd.floorList){
                                ddd.select = 0;
                                for(let dddd of ddd.roomList){
                                    dddd.select = 0;
                                }
                                this.isIndeterminateTkf[d.id+'_'+dd.id+'_'+ddd.id] = false;
                                this.roomCheckListData[d.id+'_'+dd.id+'_'+ddd.id] = [];
                                this.roomCheckListData_[d.id+'_'+dd.id+'_'+ddd.id] = [];
                            }
                        }
                    }
                }
                this.upDateUserPermissionList();
            },
            buildCheckListChange(arr,id,list,userKey){
                let type = arr.length>this.buildCheckListData_[id].length?'add':'del';
                let arr1 = arr.length>this.buildCheckListData_[id].length?arr:this.buildCheckListData_[id];
                let arr2 = arr.length<this.buildCheckListData_[id].length?arr:this.buildCheckListData_[id];
                let buildId,isTrueFloor = true;
                for(let val of arr1){
                    if(arr2.indexOf(val) == -1){
                        buildId = val;
                    }
                }
                this.buildCheckListData_[id] = JSON.parse(JSON.stringify(arr));
                if(arr.length == list.length){
                    if(this.hotelCheckList.indexOf(id) == -1){
                        this.hotelCheckList.push(id)
                        this.hotelCheckListR.push(id)
                        this.userPermissionList_.push(id)
                    }
                }else{
                    if(this.hotelCheckList.indexOf(id) != -1){
                        this.hotelCheckList.splice(this.hotelCheckList.indexOf(id),1)
                        this.hotelCheckListR.splice(this.hotelCheckListR.indexOf(id),1)
                        this.userPermissionList_.splice(this.userPermissionList_.indexOf(id),1)
                    }
                }
                this.isIndeterminateTku[userKey] = arr.length > 0 && arr.length < list.length;
                for(let d of this.userPermissionList){
                    if(d.id == id){
                        for(let dd of d.buildList){
                            console.log(buildId , dd.id)
                            if(buildId == dd.id){
                                this.isIndeterminateTkb[d.id+'_'+dd.id] = false;
                                if(type == 'add'){
                                    dd.select = 1;
                                    for(let ddd of dd.floorList){
                                        ddd.select = 1;
                                        if(this.floorCheckListData[d.id+'_'+dd.id].indexOf(ddd.id) == -1){
                                            this.floorCheckListData[d.id+'_'+dd.id].push(ddd.id)
                                            this.floorCheckListData_[d.id+'_'+dd.id].push(ddd.id)
                                        }
                                        for(let dddd of ddd.roomList){
                                            if(this.roomCheckListData[d.id+'_'+dd.id+'_'+ddd.id].indexOf(dddd.id) == -1){
                                                dddd.select = 1;
                                                this.roomCheckListData[d.id+'_'+dd.id+'_'+ddd.id].push(dddd.id)
                                                this.roomCheckListData_[d.id+'_'+dd.id+'_'+ddd.id].push(dddd.id)
                                            }
                                        }
                                    }
                                }else{
                                    dd.select = 0;
                                    this.floorCheckListData[d.id+'_'+dd.id] = [];
                                    this.floorCheckListData_[d.id+'_'+dd.id] = [];
                                    for(let ddd of dd.floorList){
                                        ddd.select = 0;
                                        this.isIndeterminateTkf[d.id+'_'+dd.id+'_'+ddd.id] = false;
                                        this.roomCheckListData[d.id+'_'+dd.id+'_'+ddd.id] = [];
                                        this.roomCheckListData_[d.id+'_'+dd.id+'_'+ddd.id] = [];
                                        for(let dddd of ddd.roomList){
                                            dddd.select = 0;
                                        }
                                    }
                                }
                                // console.log(this.buildCheckListData[d.id].length,this.buildCheckListData[d.id].length,d.buildList.length,)
                                if(this.buildCheckListData[d.id].length > 0 && this.buildCheckListData[d.id].length < d.buildList.length){
                                        this.$set(this.isIndeterminateTku,d.id,true)
                                        d.select = 1;
                                }else{
                                    if(this.buildCheckListData[d.id].length == d.buildList.length){
                                        d.select = 1;
                                    }else{
                                        d.select = 0;
                                        if(this.isIndeterminateTkb[d.id+'_'+dd.id]){
                                            this.$set(this.isIndeterminateTku,d.id,true)
                                            d.select = 1;
                                        }else{
                                            for(let key in this.isIndeterminateTkb){
                                                if(this.isIndeterminateTkb[key]&&key.split('_')[0]==d.id){
                                                    isTrueFloor = false
                                                }
                                            }
                                            console.log(this.isIndeterminateTkb,isTrueFloor)
                                            if(isTrueFloor){
                                                d.select = 0;
                                                this.$set(this.isIndeterminateTku,d.id,false)
                                            }else{
                                                d.select = 1;
                                                this.$set(this.isIndeterminateTku,d.id,true)
                                            }
                                        }
                                    }
                                }
                                this.upDateUserPermissionList();
                                if(arr.length != 0){
                                    return
                                }
                            }
                            if(!buildId){
                                dd.select = 0;
                                this.floorCheckListData[d.id+'_'+dd.id] = [];
                                this.floorCheckListData_[d.id+'_'+dd.id] = [];
                                for(let ddd of dd.floorList){
                                    ddd.select = 0;
                                    this.isIndeterminateTkf[d.id+'_'+dd.id+'_'+ddd.id] = false;
                                    this.roomCheckListData[d.id+'_'+dd.id+'_'+ddd.id] = [];
                                    this.roomCheckListData_[d.id+'_'+dd.id+'_'+ddd.id] = [];
                                    for(let dddd of ddd.roomList){
                                        dddd.select = 0;
                                    }
                                }
                            }
                        }
                    }
                }
                for(let d of this.userPermissionList){
                    if(arr.length == 0){
                        if(d.id == id&&this.buildCheckListData[d.id].length==0&&!this.isIndeterminateTku[d.id]){
                            d.select = 0;
                            this.upDateUserPermissionList();
                            return
                        }
                    }
                }
            },
            floorCheckListChange(arr,parentId,id,list,buildKey){
                let type = arr.length>this.floorCheckListData_[buildKey].length?'add':'del';
                let arr1 = arr.length>this.floorCheckListData_[buildKey].length?arr:this.floorCheckListData_[buildKey];
                let arr2 = arr.length<this.floorCheckListData_[buildKey].length?arr:this.floorCheckListData_[buildKey];
                let floorId,isTrueFloor = true;
                for(let val of arr1){
                    if(arr2.indexOf(val) == -1){
                        floorId = val;
                    }
                }
                console.log(arr,arr1,arr2,floorId)
                this.floorCheckListData_[buildKey] = JSON.parse(JSON.stringify(arr));
                if(arr.length == list.length){
                    if(this.buildCheckListData[parentId].indexOf(id) == -1){
                        this.buildCheckListData[parentId].push(id)
                        this.buildCheckListData_[parentId].push(id)
                    }
                }else{
                    if(this.buildCheckListData[parentId].indexOf(id) != -1){
                        this.buildCheckListData[parentId].splice(this.buildCheckListData[parentId].indexOf(id),1)
                        this.buildCheckListData_[parentId].splice(this.buildCheckListData_[parentId].indexOf(id),1)
                    }
                }
                this.isIndeterminateTkb[buildKey] = arr.length > 0 && arr.length < list.length;
                for(let d of this.userPermissionList){
                    for(let dd of d.buildList){
                        for(let ddd of dd.floorList){
                            if(floorId == ddd.id){
                                this.isIndeterminateTkf[d.id+'_'+dd.id+'_'+ddd.id] = false;
                                if(type == 'add'){
                                    ddd.select = 1;
                                    console.log(ddd)
                                    for(let dddd of ddd.roomList){
                                        if(this.roomCheckListData[d.id+'_'+dd.id+'_'+ddd.id].indexOf(dddd.id) == -1){
                                            dddd.select = 1;
                                            this.roomCheckListData[d.id+'_'+dd.id+'_'+ddd.id].push(dddd.id)
                                            this.roomCheckListData_[d.id+'_'+dd.id+'_'+ddd.id].push(dddd.id)
                                        }
                                    }
                                    if(this.floorCheckListData[d.id+'_'+dd.id].length > 0 && this.floorCheckListData[d.id+'_'+dd.id].length < dd.floorList.length){
                                        dd.select = 1;
                                    }else{
                                        if(this.floorCheckListData[d.id+'_'+dd.id].length == dd.floorList.length){
                                            if(this.buildCheckListData[d.id].indexOf(dd.id) != -1){
                                                dd.select = 1;
                                            }
                                        }else{
                                            if(this.buildCheckListData[d.id].indexOf(dd.id) != -1){
                                                dd.select = 0;
                                            }
                                        }
                                        if(this.isIndeterminateTkf[d.id+'_'+dd.id+'_'+ddd.id]){
                                            dd.select = 1;
                                        }
                                    }
                                }else{
                                    ddd.select = 0;
                                    for(let dddd of ddd.roomList){
                                        dddd.select = 0;
                                    }
                                    this.roomCheckListData[d.id+'_'+dd.id+'_'+ddd.id] = [];
                                    this.roomCheckListData_[d.id+'_'+dd.id+'_'+ddd.id] = [];
                                }

                                if(this.floorCheckListData[d.id+'_'+dd.id].length > 0 && this.floorCheckListData[d.id+'_'+dd.id].length < dd.floorList.length){
                                    this.$set(this.isIndeterminateTkb,d.id+'_'+dd.id,true)
                                    dd.select = 1;
                                }else{
                                    if(this.floorCheckListData[d.id+'_'+dd.id].length == dd.floorList.length){
                                        if(this.buildCheckListData[d.id].indexOf(dd.id) == -1){
                                            dd.select = 1;
                                            this.buildCheckListData[d.id].push(dd.id)
                                            this.buildCheckListData_[d.id].push(dd.id)
                                        }
                                    }else{
                                        if(this.buildCheckListData[d.id].indexOf(dd.id) != -1){
                                            dd.select = 0;
                                            this.buildCheckListData[d.id].splice(this.buildCheckListData[d.id].indexOf(dd.id),1)
                                            this.buildCheckListData_[d.id].splice(this.buildCheckListData_[d.id].indexOf(dd.id),1)
                                        }
                                        let isTkbTrue = false;
                                        for(let ddd_ of dd.floorList){
                                            if(this.isIndeterminateTkf[d.id+'_'+dd.id+'_'+ddd_.id]){
                                                isTkbTrue = true
                                            }
                                        }
                                        if(isTkbTrue){
                                            this.$set(this.isIndeterminateTkb,d.id+'_'+dd.id,true)
                                        }
                                    }
                                    if(this.isIndeterminateTkf[d.id+'_'+dd.id+'_'+ddd.id]){
                                        this.$set(this.isIndeterminateTkb,d.id+'_'+dd.id,true)
                                        dd.select = 1;
                                    }else{
                                        for(let key in this.isIndeterminateTkf){
                                            if(this.isIndeterminateTkf[key]){
                                                isTrueFloor = false
                                            }
                                        }
                                        if(isTrueFloor){
                                            this.$set(this.isIndeterminateTkb,d.id+'_'+dd.id,false)
                                        }
                                    }
                                }

                                if(this.buildCheckListData[parentId].length > 0 && this.buildCheckListData[parentId].length < d.buildList.length){
                                    this.$set(this.isIndeterminateTku,parentId,true)
                                    d.select = 1;
                                }else{
                                    if(this.isIndeterminateTkb[parentId+'_'+id]){
                                        this.$set(this.isIndeterminateTku,parentId,true)
                                        d.select = 1;
                                    }else{
                                        for(let key in this.isIndeterminateTkb){
                                            if(this.isIndeterminateTkb[key]){
                                                isTrueFloor = false
                                            }
                                        }
                                        if(isTrueFloor){
                                            d.select = 0;
                                            this.$set(this.isIndeterminateTku,parentId,false)
                                        }else{
                                            d.select = 1;
                                        }
                                        
                                        // d.select = 1;
                                    }
                                    if(this.buildCheckListData[parentId].length == d.buildList.length){
                                        if(this.hotelCheckList.indexOf(d.id) == -1){
                                            this.hotelCheckList.push(d.id)
                                            this.hotelCheckListR.push(d.id)
                                            this.userPermissionList_.push(d.id)
                                            d.select = 1;
                                        }
                                    }else{
                                        if(this.hotelCheckList.indexOf(d.id) != -1){
                                            this.hotelCheckList.splice(this.hotelCheckList.indexOf(d.id),1)
                                            this.hotelCheckListR.splice(this.hotelCheckListR.indexOf(d.id),1)
                                            this.userPermissionList_.splice(this.userPermissionList_.indexOf(d.id),1)
                                            // d.select = 0;
                                        }
                                    }

                                }
                                this.upDateUserPermissionList();
                                if(arr.length != 0){
                                    return
                                }
                            }
                            if(!floorId){
                                ddd.select = 0;
                                for(let dddd of ddd.roomList){
                                    dddd.select = 0;
                                }
                                this.roomCheckListData[d.id+'_'+dd.id+'_'+ddd.id] = [];
                                this.roomCheckListData_[d.id+'_'+dd.id+'_'+ddd.id] = [];
                            }
                        }
                    }
                }
                for(let d of this.userPermissionList){
                    if(arr.length == 0){
                        console.log(d.id,buildKey.split('_')[0],this.buildCheckListData[d.id].length,this.isIndeterminateTku[d.id])
                        if(d.id == buildKey.split('_')[0]){
                            if(this.buildCheckListData[d.id].length==0&&!this.isIndeterminateTku[d.id]){
                                d.select = 0;
                            }
                            for(let dd of d.buildList){
                                if(dd.id == buildKey.split('_')[1]){
                                    if(this.floorCheckListData[d.id+'_'+dd.id].length==0&&!this.isIndeterminateTkb[d.id+'_'+dd.id]){
                                        dd.select = 0;
                                    }
                                    this.upDateUserPermissionList();
                                    return
                                }
                            }
                        }
                    }
                }
            },
            roomCheckListChange(arr,parentId,id,list,floorKey){
                let type = arr.length>this.roomCheckListData_[floorKey].length?'add':'del';
                let arr1 = arr.length>this.roomCheckListData_[floorKey].length?arr:this.roomCheckListData_[floorKey];
                let arr2 = arr.length<this.roomCheckListData_[floorKey].length?arr:this.roomCheckListData_[floorKey];
                let roomId,isTrueFloor = true;
                for(let val of arr1){
                    if(arr2.indexOf(val) == -1){
                        roomId = val;
                    }
                }
                console.log(arr1,arr2,roomId,type)
                this.roomCheckListData_[floorKey] = JSON.parse(JSON.stringify(arr));
                if(arr.length == list.length){
                    if(this.floorCheckListData[parentId].indexOf(id) == -1){
                        this.floorCheckListData[parentId].push(id)
                        this.floorCheckListData_[parentId].push(id)
                    }
                }else{
                    if(this.floorCheckListData[parentId].indexOf(id) != -1){
                        this.floorCheckListData[parentId].splice(this.floorCheckListData[parentId].indexOf(id),1)
                        this.floorCheckListData_[parentId].splice(this.floorCheckListData[parentId].indexOf(id),1)
                    }
                }
                this.$set(this.isIndeterminateTkf,floorKey,arr.length > 0 && arr.length < list.length)
                for(let d of this.userPermissionList){
                    for(let dd of d.buildList){
                        for(let ddd of dd.floorList){
                            for(let dddd of ddd.roomList){
                                if(roomId == dddd.id){
                                    if(type == 'add'){
                                        dddd.select = 1;
                                        ddd.select = 1;
                                        dd.select = 1;
                                        d.select = 1;
                                    }else{
                                        dddd.select = 0;
                                    }
                                    if(this.roomCheckListData[floorKey].length > 0 && this.roomCheckListData[floorKey].length < ddd.roomList.length){
                                        ddd.select = 1;
                                    }else{
                                        if(this.roomCheckListData[floorKey].length == ddd.roomList.length){
                                            ddd.select = 1;
                                        }else{
                                            ddd.select = 0;
                                        }
                                    }
                                    if(this.floorCheckListData[parentId].length > 0 && this.floorCheckListData[parentId].length < dd.floorList.length){
                                        this.$set(this.isIndeterminateTkb,d.id+'_'+dd.id,true)
                                        dd.select = 1;
                                    }else{
                                        if(this.floorCheckListData[parentId].length == dd.floorList.length){
                                            if(this.buildCheckListData[d.id].indexOf(dd.id) == -1){
                                                dd.select = 1;
                                                this.buildCheckListData[d.id].push(dd.id)
                                                this.buildCheckListData_[d.id].push(dd.id)
                                            }
                                        }else{
                                            if(this.buildCheckListData[d.id].indexOf(dd.id) != -1){
                                                dd.select = 0;
                                                this.buildCheckListData[d.id].splice(this.buildCheckListData[d.id].indexOf(dd.id),1)
                                                this.buildCheckListData_[d.id].splice(this.buildCheckListData_[d.id].indexOf(dd.id),1)
                                            }
                                        }
                                        if(this.isIndeterminateTkf[floorKey]){
                                            this.$set(this.isIndeterminateTkb,floorKey.split('_')[0]+'_'+floorKey.split('_')[1],true)
                                            dd.select = 1;
                                        }else{
                                            for(let key in this.isIndeterminateTkf){
                                                if(this.isIndeterminateTkf[key]){
                                                    isTrueFloor = false
                                                }
                                            }
                                            if(isTrueFloor){
                                                this.$set(this.isIndeterminateTkb,floorKey.split('_')[0]+'_'+floorKey.split('_')[1],false)
                                            }
                                        }
                                    }

                                    console.log(this.floorCheckListData[parentId].length,dd.floorList.length,dd.floorList.length,dd,this.buildCheckListData[d.id].indexOf(dd.id))

                                    if(this.buildCheckListData[d.id].length > 0 && this.buildCheckListData[d.id].length < d.buildList.length){
                                        this.$set(this.isIndeterminateTku,d.id,true)
                                        d.select = 1;
                                    }else{
                                        if(this.buildCheckListData[d.id].length == d.buildList.length){
                                            if(this.hotelCheckList.indexOf(d.id) == -1){
                                                this.hotelCheckList.push(d.id)
                                                this.hotelCheckListR.push(d.id)
                                                this.userPermissionList_.push(d.id)
                                                d.select = 1;
                                            }
                                        }else{
                                            if(this.hotelCheckList.indexOf(d.id) != -1){
                                                this.hotelCheckList.splice(this.hotelCheckList.indexOf(d.id),1)
                                                this.hotelCheckListR.splice(this.hotelCheckListR.indexOf(d.id),1)
                                                this.userPermissionList_.splice(this.userPermissionList_.indexOf(d.id),1)
                                                d.select = 0;
                                            }
                                        }
                                        if(this.isIndeterminateTkb[d.id+'_'+dd.id]){
                                            this.$set(this.isIndeterminateTku,d.id,true)
                                            d.select = 1;
                                        }else{
                                            this.$set(this.isIndeterminateTku,d.id,false)
                                            // if(this.hotelCheckList.indexOf(d.id) != -1){
                                            //     d.select = 0;
                                            // }
                                        }
                                        
                                    }
                                    this.upDateUserPermissionList();
                                    if(arr.length != 0){
                                        return
                                    }
                                }
                                if(!roomId){
                                    dddd.select = 0;
                                }
                            }
                        }
                    }
                }
                for(let d of this.userPermissionList){
                    if(arr.length == 0){
                        console.log(d.id,floorKey.split('_')[0],this.buildCheckListData[d.id].length,this.isIndeterminateTku[d.id])
                        if(d.id == floorKey.split('_')[0]){
                            if(this.buildCheckListData[d.id].length==0&&!this.isIndeterminateTku[d.id]){
                                d.select = 0;
                            }
                            for(let dd of d.buildList){
                                if(dd.id == floorKey.split('_')[1]){
                                    console.log(dd,this.floorCheckListData[d.id+'_'+dd.id].length,this.isIndeterminateTkb[d.id+'_'+dd.id])
                                    if(this.floorCheckListData[d.id+'_'+dd.id].length==0&&!this.isIndeterminateTkb[d.id+'_'+dd.id]){
                                        dd.select = 0;
                                    }
                                    this.upDateUserPermissionList();
                                    return
                                }
                            }
                        }
                    }
                }
            },
            hotelShowFun(data,isTrue){
                if(isTrue){
                    if(data.show){
                        data.show = false;
                    }else{
                        data.show = true;
                    }
                }
            },
            buildShowFun(data,isTrue){
                if(isTrue){
                    if(data.show){
                        data.show = false;
                    }else{
                        data.show = true;
                    }
                }
            },
            floorShowFun(data,isTrue){
                if(isTrue){
                    if(data.show){
                        data.show = false;
                    }else{
                        data.show = true;
                    }
                }
            },
            AddUser(){
                this.userId = '';
                this.infoType = 'add';
                this.personnelInformationTkShowbg = true;
                this.$nextTick(function(){
                    this.personnelInformationTkShow = true;
                })
                for(let key in this.userForm){
                    this.userForm[key] = '';
                }
            },
            /*获取用户详情*/
            getUserInfo(obj){
                this.objRole = obj.role;
                this.infoType = 'edit';
                base.ajax_post(
                    allUrl.userManagement.userInfo,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        userId:obj.id,
                    },
                    {},
                    data=>{
                        this.userForm = data.data;
                        console.log(data)
                    },
                    this
                )
                this.personnelInformationTkShowbg = true;
                this.$nextTick(function(){
                    this.personnelInformationTkShow = true;
                })
            },
            personnelInformationTkClose(){
                let this_ = this;
                this.personnelInformationTkShow = false;
                setTimeout(function(){
                    this_.personnelInformationTkShowbg = false;
                },1000)
            },
            /*启用禁用用户状态*/
            setUserStatus(obj){
                if(obj.status == 0){
                    obj.status = 1
                }else{
                    obj.status = 0
                }
                base.ajax_post(
                    allUrl.userManagement.setUserStatus,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        userId:obj.id,
                        status:obj.status,
                    },
                    {},
                    data=>{
                        this.$message({
                          showClose: true,
                          message: data.msg,
                          type: 'success'
                        });
                    },
                    this,()=>{
                        if(obj.status == 0){
                            obj.status = 1
                        }else{
                            obj.status = 0
                        }
                    }
                )
            },
            /*添加编辑用户*/
            userFormVerification(){
                let isTrue = true;
                // if(this.userForm.user.length>20||this.userForm.user.length<4){
                //     isTrue = false
                //     this.$alert(this.$t('App.userManagement.text11'), this.$t('App.message.text1'), {
                //         confirmButtonText: this.$t('App.message.text2'),
                //     });
                // }
                // if(this.userForm.userId.length>20||this.userForm.userId.length<4){
                //     isTrue = false
                //     this.$alert(this.$t('App.userManagement.text12'), this.$t('App.message.text1'), {
                //         confirmButtonText: this.$t('App.message.text2'),
                //     });
                // }
                return isTrue;
            },
            postSaveUser(){
                if(this.userFormVerification()){
                    base.ajax_post(
                        allUrl.userManagement.saveUser,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            id:this.userId,
                            ...this.userForm,
                        },
                        {},
                        data=>{
                            console.log(this.role)
                            this.$message({
                              showClose: true,
                              message: data.msg,
                              type: 'success'
                            });
                            if(this.objRole == '1'){
                                var storage = window.localStorage;
                                storage.setItem('userData','')
                                this.$store.commit('ROUTERSTRFUN',{
                                  routerStr:'/login',
                                })
                                this.$router.push({path:'/login'})
                                
                                // if(this.version == '0'){
                                //     document.title = 'inHealth-'+val.split('/')[1]
                                // }
                                // if(this.version == '1'){
                                //     document.title = '工业照明-'+val.split('/')[1]
                                // }
                            }else{
                                this.personnelInformationTkShowbg = false;
                                this.$nextTick(function(){
                                    this.personnelInformationTkShow = false;
                                })
                                this.getUserList();
                                this.getUserManage();
                            }
                        },
                        this
                    )
                }
            },
            /*获取用户列表*/
            getUserPermission(){
                base.ajax_post(
                    allUrl.userManagement.getUserPermission,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        userId:this.userId,
                    },
                    {},
                    data=>{
                        console.log(data.data.list)
                        this.deviceAuth = [];
                        for(let d of this.deviceAuthArr){
                            if(data.data.lightAuth ==1){
                                if(d.key == 'lightAuth'){
                                    this.deviceAuth.push(d.key)
                                    d.select = 1;
                                }
                            }
                            if(data.data.cirLight ==1){
                                if(d.key == 'cirLight'){
                                    this.deviceAuth.push(d.key)
                                    d.select = 1;
                                }
                            }
                            if(data.data.sensorAuth ==1){
                                if(d.key == 'sensorAuth'){
                                    this.deviceAuth.push(d.key)
                                    d.select = 1;
                                }
                            }
                            if(data.data.airPurifierAuth ==1){
                                if(d.key == 'airPurifierAuth'){
                                    this.deviceAuth.push(d.key)
                                    d.select = 1;
                                }
                            }
                        }
                        this.deviceAuthAll = this.deviceAuth.length == this.deviceAuthArr.length;
                        this.deviceAuthAllInde = this.deviceAuth.length>0&&this.deviceAuth.length<this.deviceAuthArr.length;

                        this.$set(this,'userPermissionList',data.data.list);
                        this.hotelCheckList = [];
                        this.hotelCheckListR = [];
                        this.userPermissionList_ = [];
                        let ddIndex = 0;
                        let dddIndex = 0;
                        let ddddIndex = 10;
                        for(let d of this.userPermissionList){
                            this.$set(this.isIndeterminateTku,d.id,false);
                            this.$set(this.buildCheckListData,d.id,[]);
                            this.$set(this.buildCheckListData_,d.id,[]);
                            this.$set(d,'show',false)
                            this.$set(this.buildCheckListDataLength,d.id,0);
                            if(d.select == 1){
                                this.hotelCheckList.push(d.id)
                                this.hotelCheckListR.push(d.id)
                                this.userPermissionList_.push(d.id)
                                if(d.buildList.length >0){
                                    this.isIndeterminateTku[d.id] = true;
                                }
                            }
                            // dIndex++;
                            ddIndex = 0;
                            for(let dd of d.buildList){
                                this.$set(this.isIndeterminateTkb,d.id+'_'+dd.id,false);
                                this.$set(this.floorCheckListData,d.id+'_'+dd.id,[]);
                                this.$set(this.floorCheckListData_,d.id+'_'+dd.id,[]);
                                this.$set(dd,'show',false)
                                this.$set(this.floorCheckListDataLength,dd.id,0);
                                this.buildCheckListDataLength[d.id]++;
                                if(dd.select == 1){
                                    this.buildCheckListData[d.id].push(dd.id);
                                    this.buildCheckListData_[d.id].push(dd.id);
                                    if(dd.floorList.length >0){
                                        this.isIndeterminateTkb[d.id+'_'+dd.id] = true;
                                    }
                                }else{
                                    if(this.hotelCheckList.indexOf(d.id) != -1){
                                        this.hotelCheckList.splice(this.hotelCheckList.indexOf(d.id),1);
                                        this.hotelCheckListR.splice(this.hotelCheckListR.indexOf(d.id),1);
                                        this.userPermissionList_.splice(this.userPermissionList_.indexOf(d.id),1);
                                    }
                                    // this.isIndeterminateTku[d.id] = true;
                                }
                                ddIndex++;
                                dddIndex = 0;
                                if(ddIndex == d.buildList.length){
                                    if(this.buildCheckListData[d.id].length == d.buildList.length){
                                        this.isIndeterminateTku[d.id] = false;
                                    }
                                    if(this.hotelCheckList.indexOf(d.id) != -1&&this.isIndeterminateTku[d.id]&&this.buildCheckListData[d.id].length!=0){
                                        this.hotelCheckList.splice(this.hotelCheckList.indexOf(d.id),1);
                                        this.hotelCheckListR.splice(this.hotelCheckListR.indexOf(d.id),1);
                                        this.userPermissionList_.splice(this.userPermissionList_.indexOf(d.id),1);
                                    }
                                }
                                for(let ddd of dd.floorList){
                                    this.$set(this.isIndeterminateTkf,d.id+'_'+dd.id+'_'+ddd.id,false);
                                    this.$set(this.roomCheckListData,d.id+'_'+dd.id+'_'+ddd.id,[]);
                                    this.$set(this.roomCheckListData_,d.id+'_'+dd.id+'_'+ddd.id,[]);
                                    this.floorCheckListDataLength[dd.id]++;
                                    this.$set(ddd,'show',false)
                                    if(ddd.select == 1){
                                        this.floorCheckListData[d.id+'_'+dd.id].push(ddd.id)
                                        this.floorCheckListData_[d.id+'_'+dd.id].push(ddd.id)
                                        if(ddd.roomList.length >0){
                                            this.isIndeterminateTkf[d.id+'_'+dd.id+'_'+ddd.id] = true;
                                        }
                                    }
                                    dddIndex++;
                                    ddddIndex = 0;
                                    if(dddIndex == dd.floorList.length){
                                        if(this.floorCheckListData[d.id+'_'+dd.id].length == dd.floorList.length){
                                            this.isIndeterminateTkb[d.id+'_'+dd.id] = false;
                                        }
                                        if(this.buildCheckListData[d.id].indexOf(dd.id) != -1&&this.isIndeterminateTkb[d.id+'_'+dd.id]&&this.floorCheckListData[d.id+'_'+dd.id].length!=0){
                                            this.buildCheckListData[d.id].splice(this.buildCheckListData[d.id].indexOf(dd.id),1);
                                            this.buildCheckListData_[d.id].splice(this.buildCheckListData_[d.id].indexOf(dd.id),1);
                                        }
                                    }
                                    for(let dddd of ddd.roomList){
                                        this.$set(dddd,'show',false)
                                        if(dddd.select == 1){
                                            this.roomCheckListData[d.id+'_'+dd.id+'_'+ddd.id].push(dddd.id)
                                            this.roomCheckListData_[d.id+'_'+dd.id+'_'+ddd.id].push(dddd.id)
                                        }
                                        ddddIndex++
                                        if(ddddIndex == ddd.roomList.length){
                                            if(this.roomCheckListData[d.id+'_'+dd.id+'_'+ddd.id].length == ddd.roomList.length){
                                                this.isIndeterminateTkf[d.id+'_'+dd.id+'_'+ddd.id] = false;
                                            }
                                            if(this.floorCheckListData[d.id+'_'+dd.id].indexOf(ddd.id) != -1&&this.isIndeterminateTkf[d.id+'_'+dd.id+'_'+ddd.id]&&this.roomCheckListData[d.id+'_'+dd.id+'_'+ddd.id].length!=0){
                                                this.floorCheckListData[d.id+'_'+dd.id].splice(this.floorCheckListData[d.id+'_'+dd.id].indexOf(ddd.id),1);
                                                this.floorCheckListData_[d.id+'_'+dd.id].splice(this.floorCheckListData_[d.id+'_'+dd.id].indexOf(ddd.id),1);
                                            }
                                            
                                        }
                                    }
                                }
                            }
                        }
                        this.upDateUserPermissionList();
                    },
                    this
                )
            },
            /*获取用户列表*/
            getUserListKeyUp(e){
                if(e.key == 'Enter'){
                    this.getUserList();
                    this.getUserManage();
                }
            },
            getUserList(callback){
                base.ajax_post(
                    allUrl.userManagement.userList,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        page:this.currentPage,
                        count:this.pageSize,
                        keywords:this.keywords,
                    },
                    {},
                    data=>{
                        this.userDataList = data.data.list;
                        this.total = Number(data.data.total);

                        this.userDataIdList = [];
                        this.checkList = [];
                        this.isIndeterminate = false;
                        this.checkAll = false;
                        for(let d of this.userDataList){
                            this.userDataIdList.push(d.id);
                        }
                        let i = 1;
                        for(let d of this.userDataList){
                            d.webIndex = i;
                            i++;
                        }
                        if(callback){
                            callback(data)
                        }
                    },
                    this
                )
            },
            /*用户概览信息*/
            getUserManage(){
                base.ajax_post(
                    allUrl.userManagement.userManage,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                    },
                    {},
                    data=>{
                        this.userManage = data.data;
                    },
                    this
                )
            },
            treeLAllChange(val){
                this.$set(this,'hotelCheckList',[])
                this.$set(this,'hotelCheckListR',[])
                this.$set(this,'userPermissionList_',[])
                if(val){
                    for(let d of this.userPermissionList){
                        if(this.hotelCheckList.indexOf(d.id) == -1){
                            this.hotelCheckList.push(d.id)
                            this.hotelCheckListR.push(d.id)
                            this.userPermissionList_.push(d.id)
                        }
                        d.select = 1;
                        this.$set(this.isIndeterminateTku,d.id,false);
                        for(let dd of d.buildList){
                            if(this.buildCheckListData[d.id].indexOf(dd.id) == -1){
                                this.buildCheckListData[d.id].push(dd.id);
                                this.buildCheckListData_[d.id].push(dd.id);
                            }
                            dd.select = 1;
                            this.$set(this.isIndeterminateTkb,d.id+'_'+dd.id,false);
                            for(let ddd of dd.floorList){
                                if(this.floorCheckListData[d.id+'_'+dd.id].indexOf(ddd.id) == -1){
                                    this.floorCheckListData[d.id+'_'+dd.id].push(ddd.id);
                                    this.floorCheckListData_[d.id+'_'+dd.id].push(ddd.id);
                                }
                                ddd.select = 1;
                                this.$set(this.isIndeterminateTkf,d.id+'_'+dd.id+'_'+ddd.id,false);
                                for(let dddd of ddd.roomList){
                                    if(this.roomCheckListData[d.id+'_'+dd.id+'_'+ddd.id].indexOf(dddd.id) == -1){
                                        this.roomCheckListData[d.id+'_'+dd.id+'_'+ddd.id].push(dddd.id)
                                        this.roomCheckListData_[d.id+'_'+dd.id+'_'+ddd.id].push(dddd.id)
                                    }
                                    dddd.select = 1;
                                }
                            }
                        }
                    }
                }else{
                    this.treeLAll = false;
                    for(let d of this.userPermissionList){
                        d.select = 0;
                        this.$set(this.isIndeterminateTku,d.id,false);
                        this.$set(this.buildCheckListData,d.id,[]);
                        this.$set(this.buildCheckListData_,d.id,[]);
                        for(let dd of d.buildList){
                            dd.select = 0;
                            this.$set(this.isIndeterminateTkb,d.id+'_'+dd.id,false);
                            this.$set(this.floorCheckListData,d.id+'_'+dd.id,[]);
                            this.$set(this.floorCheckListData_,d.id+'_'+dd.id,[]);
                            for(let ddd of dd.floorList){
                                ddd.select = 0;
                                this.$set(this.isIndeterminateTkf,d.id+'_'+dd.id+'_'+ddd.id,false);
                                this.$set(this.roomCheckListData,d.id+'_'+dd.id+'_'+ddd.id,[]);
                                this.$set(this.roomCheckListData_,d.id+'_'+dd.id+'_'+ddd.id,[]);
                                for(let dddd of ddd.roomList){
                                    dddd.select = 0;
                                }
                            }
                        }
                    }
                }
                this.upDateUserPermissionList('All');
            },
            handleAvatarSuccess(res, file) {
                console.log(res,file)
                this.userForm.avatar = res.data.path;
            },
            beforeAvatarUpload(file) {
                // const isJPG = file.type === 'image/jpeg';
                // const isLt2M = file.size / 1024 / 1024 < 2;

                // if (!isJPG) {
                //     this.$message.error('上传头像图片只能是 JPG 格式!');
                // }
                // if (!isLt2M) {
                //     this.$message.error('上传头像图片大小不能超过 2MB!');
                // }
                // return isJPG && isLt2M;
                const isJPG = file.type === 'image/jpeg';
                const isPNG = file.type === 'image/png';
                const isLt2M = file.size / 1024 / 1024 < 2;

                if (!isJPG&&!isPNG) {
                    this.$message.error(this.$t('App.message.text29'));
                }
                if (!isLt2M) {
                    this.$message.error(this.$t('App.message.text30'));
                }
                return (isJPG||isPNG) && isLt2M;
            },
            // personnelInformationFun(){
            // },
            permissionSettingsFun(data){
                this.permissionSettingsTkShowbg = true;
                this.userId = data.id
                this.getUserPermission()
                this.$nextTick(function(){
                    this.permissionSettingsTkShow = true;
                })
            },
            /*编辑用户权限*/
            setUserPermission(){
                let roomId = '',floorId = '',buildId = '',hotelId = '';
                for(let d of this.userPermissionList){
                    if(d.select == 1){
                        if(hotelId == ''){
                            hotelId = d.id;
                        }else{
                            hotelId = hotelId+','+d.id;
                        }
                    }
                    for(let dd of d.buildList){
                        if(dd.select == 1){
                            if(buildId == ''){
                                buildId = dd.id;
                            }else{
                                buildId = buildId+','+dd.id;
                            }
                        }
                        for(let ddd of dd.floorList){
                            if(ddd.select == 1){
                                if(floorId == ''){
                                    floorId = ddd.id;
                                }else{
                                    floorId = floorId+','+ddd.id;
                                }
                            }
                            for(let dddd of ddd.roomList){
                                if(dddd.select == 1){
                                    if(roomId == ''){
                                        roomId = dddd.id;
                                    }else{
                                        roomId = roomId+','+dddd.id;
                                    }
                                }
                            }
                        }
                    }
                }
                // console.log(roomId ,floorId ,buildId,hotelId)
                this.deviceAuth
                let lightAuth = 0;
                let cirLight = 0;
                let sensorAuth = 0;
                let airPurifierAuth = 0;
                for(let val of this.deviceAuth){
                    if(val == 'lightAuth'){
                        lightAuth = 1;
                    }
                    if(val == 'cirLight'){
                        cirLight = 1;
                    }
                    if(val == 'sensorAuth'){
                        sensorAuth = 1;
                    }
                    if(val == 'airPurifierAuth'){
                        airPurifierAuth = 1;
                    }
                }
                base.ajax_post(
                    allUrl.userManagement.setUserPermission,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        userId:this.userId,
                        roomId:roomId,
                        floorId:floorId,
                        buildId:buildId,
                        hotelId:hotelId,
                        lightAuth:lightAuth,
                        cirLight:cirLight,
                        sensorAuth:sensorAuth,
                        airPurifierAuth:airPurifierAuth,
                    },
                    {},
                    data=>{
                        this.$message({
                          showClose: true,
                          message: data.msg,
                          type: 'success'
                        });

                        this.permissionSettingsTkShowbg = false;
                        this.$nextTick(function(){
                            this.permissionSettingsTkShow = false;
                        })
                    },
                    this
                )
            },
            permissionSettingsTkClose(){
                let this_ = this;
                this.permissionSettingsTkShow = false;
                setTimeout(function(){
                    this_.permissionSettingsTkShowbg = false;
                },1000)
            },
            /*删除日志*/
            postDelUser(obj,type){
                let userId = '',isTrue = true;
                if(type == 'batch'){
                    if(obj.length == 0){
                        isTrue = false;
                        this.$message({
                            message: this.$t('App.message.text23'),
                            type: 'warning'
                        });
                    }else{
                        for(let id of obj){
                            if(userId == ''){
                                userId = id;
                            }else{
                                userId += ','+id;
                            }
                        }
                    }
                }else{
                    userId = obj.id;
                }
                if(isTrue){
                    this.$confirm(
                        this.$t('App.message.text31'), this.$t('App.message.text17'), {
                            confirmButtonText: this.$t('App.message.text2'),
                            cancelButtonText: this.$t('App.message.text6'),
                            type: 'warning'
                        }
                    ).then(() => {
                        base.ajax_post(
                            allUrl.userManagement.delUser,
                            {
                                username:this.username,
                                client_key:this.client_key,
                                token:this.token,
                                userId:userId,
                            },
                            {},
                            data=>{
                                this.$message({
                                  showClose: true,
                                  message: data.msg,
                                  type: 'success'
                                });
                                this.getUserList();
                                this.getUserManage();
                            },
                            this
                        )
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: this.$t('App.message.text18')
                        });          
                    });
                }
            },
            /*分页*/
            // handleSizeChange(val) {
            //  this.pageSize = val;
            //  this.getUserList();
            // },
            // handleCurrentChange() {
            //  // console.log(val)
            // },
            handleCheckAllChange(val) {
                this.checkList = val ? this.userDataIdList : [];
                this.isIndeterminate = false;
            },
            handleCheckedCitiesChange(value){
                let checkedCount = value.length;
                this.checkAll = checkedCount === this.userDataIdList.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.userDataIdList.length;
            },
            upDateUserPermissionList(type){
                if(!type){
                    this.treeLAll = false;
                }
                // console.log('--------')
                let newName_ = JSON.parse(JSON.stringify(this.userPermissionList));
                if(newName_[0].buildList){
                    for(let a=0;a<newName_.length;a++){
                        if(newName_[a].select == 0){
                            newName_.splice(a,1)
                            a--;
                        }else{
                            for(let b=0;b<newName_[a].buildList.length;b++){
                                if(newName_[a].buildList[b].select == 0){
                                    newName_[a].buildList.splice(b,1)
                                    b--;
                                }else{
                                    for(let c=0;c< newName_[a].buildList[b].floorList.length;c++){
                                        if(newName_[a].buildList[b].floorList[c].select == 0){
                                            newName_[a].buildList[b].floorList.splice(c,1)
                                            c--;
                                        }else{
                                            for(let d=0;d<newName_[a].buildList[b].floorList[c].roomList.length;d++){
                                                if(newName_[a].buildList[b].floorList[c].roomList[d].select == 0){
                                                    newName_[a].buildList[b].floorList[c].roomList.splice(d,1)
                                                    d--;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    this.userPermissionListR = newName_;
                }
            }
        },
        watch: {
            // userPermissionList:{
            //     deep: true,
            //     handler(newName) {
            //         let newName_ = JSON.parse(JSON.stringify(newName));
            //         if(newName_[0].buildList){
            //             for(let a=0;a<newName_.length;a++){
            //                 if(newName_[a].select == 0){
            //                     newName_.splice(a,1)
            //                     a--;
            //                 }else{
            //                     for(let b=0;b<newName_[a].buildList.length;b++){
            //                         if(newName_[a].buildList[b].select == 0){
            //                             newName_[a].buildList.splice(b,1)
            //                             b--;
            //                         }else{
            //                             for(let c=0;c< newName_[a].buildList[b].floorList.length;c++){
            //                                 // console.log(a,b,c,newName_[a].buildList[b].floorList[c])
            //                                 if(newName_[a].buildList[b].floorList[c].select == 0){
            //                                     // console.log(newName_[a].buildList[b].floorList[c].number)
            //                                     newName_[a].buildList[b].floorList.splice(c,1)
            //                                     c--;
            //                                 }else{
            //                                     for(let d=0;d<newName_[a].buildList[b].floorList[c].roomList.length;d++){
            //                                         if(newName_[a].buildList[b].floorList[c].roomList[d].select == 0){
            //                                             newName_[a].buildList[b].floorList[c].roomList.splice(d,1)
            //                                             d--;
            //                                         }
            //                                     }
            //                                 }
            //                             }
            //                         }
            //                     }
            //                 }
            //             }
            //             this.userPermissionListR = newName_;
            //             console.log(newName_,this.userPermissionList,newName);
            //         }
            //     }
            // }
        }
    }
</script>

<style type="text/css" lang="less">
    .userManagement_main{
        width: 100%;
        height: 100%;
        // height: 105rem;
        min-height: 50rem;
        // min-width: 120rem;
        margin: 0 auto;
        overflow: hidden;
        position: relative;
        display: flex;
        background: #F6F8FA;
        &.cn{
            .userManagement_right{
                .userManagement_right_top .right_top_l > .el-input .el-icon-search{
                    background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                }
                .userManagement_echarts_box .flex_ul .flex_li.li1 .p1{
                    color: #8266C7;
                }
                .userManagement_right_main .main_cont{
                    .el-table .status .pl_switch.checked::after{
                        background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                    }
                    .el-table .btn:hover i{
                        color: #8266C7;
                    }
                }
            }
            .personnelInformation_wrap .personnelInformation_box .btn_box .btn{
                background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
            }
            .permissionSettings_wrap .tree_box{
                .el-checkbox__input.is-checked .el-checkbox__inner{
                    background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                    border-color: #8266C7;
                }
                .el-checkbox__input.is-indeterminate .el-checkbox__inner{
                    background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                    border-color: #8266C7;
                }
            } 
            .permissionSettings_wrap .permissionSettings_box .btn_box .btn{
                background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
            }
        }
        .userManagement_left{
            width: 11.67rem;
            height: 100%;
            min-width: 130px;
        }
        .userManagement_right{
            position: relative;
            padding: 1.92rem 1.5rem 0;
            width: calc(100% - 11.67rem);
            height: calc(100%);
            .userManagement_right_top{
                display: flex;
                justify-content: space-between;
                .right_top_l{
                    .el-input__inner{
                        height: 2.5rem;line-height: 2.5rem;
                        border-radius: 1.25rem;
                        font-family: AlibabaPuHuiTiR;
                        font-size: 1rem;
                        color: #333333;
                        border-color: #F0F0F0;
                    }
                    .el-input__icon{
                        height: 2.5rem;line-height: 2.5rem;
                    }
                    .el-select{
                        margin-right: 1rem;
                        width: 11.42rem;
                    }
                    >.el-input{
                        margin-left: 1rem;
                        width: 18rem;
                        .el-icon-search{
                            display: inline-block;
                            top: 0;bottom: 0;
                            right: 0;
                            width: 4rem;
                            background: #05CFAB;
                            border-radius: 1.25rem;
                            cursor: pointer;
                            color: #FFFFFF;
                        }
                        .el-input__suffix{
                            right: 0;
                        }
                    }
                }
                .right_top_r{
                    display: flex;
                    .btn{
                        margin-left: 1rem;
                        height: 2.5rem;line-height: 2.5rem;
                        padding: 0 1.25rem;
                        background: #FFFFFF;
                        border: 1px solid #F0F0F0;
                        border-radius: 1.25rem;
                        font-family: AlibabaPuHuiTiR;
                        font-size: 1rem;
                        color: #333333;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        img{
                            margin-right: 0.5rem;
                            height: 1rem;
                        }
                    }
                }
            }
            .userManagement_echarts_box{
                margin-top: 1rem;
                height: 13.5rem;
                background: #FFFFFF;
                border: 1px solid #F0F0F0;
                border-radius: 0.4rem;
                padding: 0 1.67rem;
                background-image: url('../img/user_management_bg.png');
                background-position: center;
                background-size: 100% 100%;
                .userManagement_title{
                    display: flex;
                    justify-content: space-between;
                    margin: 1.5rem 0 1rem;
                    .text{
                        font-family: AlibabaPuHuiTiB;
                        font-size: 1.5rem;
                        color: #333333;
                    }
                    .el-dropdown{
                        cursor: pointer;
                        i{
                            color: #A3AFBB;
                        }
                    }
                }
                .flex_ul{
                    width: 63rem;
                    display: flex;
                    .flex_li{
                        flex: 1;
                        text-align: center;
                        &.li1{
                            .p1{
                                color: #05CFAB;
                            }
                        }
                    }
                    .border{
                        height:5.08rem;
                        border: 1px solid #F0F0F0;
                    }
                    .p1{
                        font-family: PingFang-SC-Heavy;
                        font-size: 2.5rem;
                        color: #333333;
                    }
                    .p2{
                        font-family: AlibabaPuHuiTiR;
                        font-size: 1rem;
                        color: #333333;
                    }
                }
            }
            .userManagement_right_main{
                height: calc(100% - 20rem);
                margin-top: 1rem;
                position: relative;
                background: #FFFFFF;
                border: 1px solid #F0F0F0;
                border-radius: 0.4rem;
                .main_top{
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    height: 3.2rem;line-height: 3.2rem;
                    .main_top_l{
                        margin-left: 1.67rem;
                        display: flex;
                        .btn{
                            margin-left: 1.29rem;
                            display: flex;align-items: center;
                            font-family: AlibabaPuHuiTiR;
                            font-size: 1rem;
                            color: #333333;
                            cursor: pointer;
                            i{
                                font-size:0.8rem;
                                color: #C6CDD5;
                            }
                            span{
                                margin-left: 0.5rem;
                            }
                        }
                    }
                }
                .main_cont{
                    height: calc(100% - 3.2rem);
                    .el-checkbox-group{
                        height: 100%;
                    }
                    .el-table{
                        .el-checkbox{
                            margin-left: 1.1rem;
                        }
                        .p{
                            overflow: hidden;
                            text-overflow:ellipsis;
                            white-space: nowrap;
                        }
                        .btn{
                            padding: 0.5rem;
                            cursor: pointer;
                            &+.btn{
                                margin-left: 0.2rem;
                            }
                            i{
                                color: #A3AFBB;
                                font-size:0.8rem;
                            }
                            &:hover{
                                i{
                                    color: #05CFAB;
                                }
                            }
                        }
                        th{
                            font-weight:initial;
                            height: 3rem;
                            border-top: 1px solid #F0F0F0;
                            border-bottom: 1px solid #F0F0F0;
                            padding: 0;
                            background: #F6F8FA;
                            &>.cell{
                                font-family: AlibabaPuHuiTiR;
                                font-size: 1rem;
                                color: #333333;
                            }
                        }
                        td{
                            padding: 0;
                            height: 3rem;
                            &>.cell,.el-checkbox__label{
                                font-family: AlibabaPuHuiTiR;
                                font-size: 1rem;
                                color: #657085;
                            }
                        }
                        .status{
                            display: flex;
                            align-items: center;
                            .pl_switch{
                                margin: 0 auto;
                                position: relative;
                                display: inline-block;
                                width: 2.33rem;
                                height: 1.3rem;
                                background: #E1EAF1;
                                border-radius: 1.08rem;
                                cursor: pointer;
                                &::after{
                                    position: absolute;
                                    left: 0.2rem;top: 0.15rem;
                                    width: 0.93rem;height: 0.93rem;border-radius: 50%;
                                    content: '';
                                    background: #A3AFBB;
                                    transition: all 0.5s;
                                }
                                &.checked{
                                    background: #E1F1E7;
                                    &::after{
                                        left: 1.15rem;
                                        background: #05CFAB;
                                    }
                                }
                            }
                        }
                    }
                    .pagination_box{
                        .el-pagination{
                            float: right;
                            margin-top: 0.5rem;
                        }
                        height: 2.5rem;line-height: 2.5rem;
                        .btn-prev .el-icon{
                            font-size:1rem;
                            color: #666666;
                            font-family: PingFang-SC-Medium;
                        }
                        button{
                            width: 2.33rem;height: 2.33rem;line-height: 2.33rem;
                            padding: 0;
                            background: #F6F8FA;
                            border-radius: 0.2rem;
                        }
                        .el-pager li{
                            margin-left: 0.83rem;
                            width: 2.33rem;height: 2.33rem;line-height: 2.33rem;
                            padding: 0;
                            background: #F6F8FA;
                            border-radius: 0.2rem;
                            &:hover{
                                color: rgba(5,207,171,1);
                                background-color: rgba(5,207,171,0.1);
                            }
                        }
                        .btn-next{
                            margin-left: 0.83rem;
                        }
                        .el-pager li.active{
                            background: #05CFAB;
                            color: #FFFFFF;
                        }
                    }
                }
            }
        }
        .personnelInformation_wrap{
            position: fixed;
            top: 0;left: 0;right: 0;bottom: 0;
            z-index: 2000;
            .personnelInformation_wrap_bg{
                position: absolute;
                top: 0;left: 0;width: 100%;height: 100%;min-height: 66rem;
                background-color:rgba(57,57,57,0.3);
            }
            .personnelInformation_box{
                position: absolute;
                width: 36rem;height: 100%;
                min-height: 66rem;
                background: #FFFFFF;
                box-shadow: 0 0 8px 0 rgba(0,0,0,0.12);
                right: -36rem;
                transition: all 1s;
                &.personnelInformation_tk_show{
                    right: 0rem; 
                }
                .personnelInformation_title{
                    height: 4.1rem;line-height: 4.1rem;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 2.5rem 0 2.5rem;
                    border: 0.1rem solid rgba(240,240,240,1);
                    .span1{
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #333333;
                    }
                    .span2{
                        padding: 0 0.5rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #999999;
                        cursor: pointer;
                    }
                }
                .form{
                    margin-top: 1.96rem;
                    .avatar-uploader {
                        margin-bottom: 2rem;
                        .el-upload {
                            border: 1px solid #EBEFF2;
                            width: 8.33rem;
                            display: block;
                            margin: 0 auto;
                            border-radius: 50%;
                            cursor: pointer;
                            position: relative;
                            // overflow: hidden;
                            // &:hover {
                            //  border-color: #409EFF;
                            // }
                            .avatar-uploader-icon {
                                font-size: 28px;
                                color: #8c939d;
                                width: 8.33rem;
                                height: 8.33rem;
                                line-height: 8.33rem;
                                text-align: center;
                            }
                            .avatar {
                                width: 8.33rem;
                                height: 8.33rem;
                                display: block;
                            }
                            .phone_icon{
                                position: absolute;
                                width: 2.33rem;height: 2.33rem;
                                right: 0;bottom: 0;
                            }
                        }
                    }
                    .form_item{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        height: 3.33rem;line-height: 3.33rem;
                        margin: 0 2.5rem 1.67rem;
                        padding: 0 1.67rem 0 1.08rem;
                        background: #F6F8F7;
                        .laber{
                            font-family: PingFang-SC-Medium;
                            font-size: 1rem;
                            color: #333333;
                        }
                        .el-dropdown{
                            cursor: pointer;
                            i{
                                margin-left: 1.67rem;
                            }
                        }
                        .el-input{
                            width: calc(100% - 8rem);
                            .el-input__inner{
                                font-family: PingFang-SC-Medium;
                                font-size: 1rem;
                                color: #657085;
                                text-align: right;
                                background: initial;
                                border: none;
                            }
                        }
                    }
                }
                .btn_box{
                    position: absolute;
                    width: 100%;
                    bottom: 1.67rem;
                    .btn{
                        width: 11.67rem;height: 2.67rem;line-height: 2.67rem;
                        margin: 0 auto;
                        background: #05CFAB;
                        border-radius: 0.2rem;
                        text-align:center;
                        cursor: pointer;
                        font-family: PingFang-SC-Medium;
                        font-size: 1rem;
                        color: #FFFFFF;
                    }
                }
            }
        }
        .permissionSettings_wrap{
            position: fixed;
            top: 0;left: 0;right: 0;bottom: 0;
            z-index: 2000;
            .permissionSettings_wrap_bg{
                position: absolute;
                top: 0;left: 0;width: 100%;height: 100%;min-height: 50rem;
                background-color:rgba(57,57,57,0.3);
            }
            .permissionSettings_box{
                position: absolute;
                width: 47rem;height: 100%;
                min-height: 50rem;
                background: #FFFFFF;
                box-shadow: 0 0 8px 0 rgba(0,0,0,0.12);
                right: -36rem;
                transition: all 1s;
                &.permissionSettings_tk_show{
                    right: 0rem; 
                }
                .permissionSettings_title{
                    height: 4.1rem;line-height: 4.1rem;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 2.5rem 0 2.5rem;
                    border: 0.1rem solid rgba(240,240,240,1);
                    .span1{
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #333333;
                    }
                    .span2{
                        padding: 0 0.5rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #999999;
                        cursor: pointer;
                    }
                }
                .btn_box{
                    position: absolute;
                    width: 100%;
                    bottom: 1.67rem;
                    .btn{
                        width: 11.67rem;height: 2.67rem;line-height: 2.67rem;
                        margin: 0 auto;
                        background: #05CFAB;
                        border-radius: 0.2rem;
                        text-align:center;
                        cursor: pointer;
                        font-family: PingFang-SC-Medium;
                        font-size: 1rem;
                        color: #FFFFFF;
                    }
                }
            }
            .tree_box{
                display: flex;
                margin: 2.5rem 2.5rem 0;
                background: #F6F8F7;
                border: 1px solid #F0F0F0;
                height: calc(100% - 14rem);
                
                .el-checkbox__input{
                    &.is-checked,&.is-indeterminate{
                        .el-checkbox__inner{
                            background-color:rgba(5, 207, 171, 1);
                            border-color:rgba(5, 207, 171, 1);
                        }
                    }
                }
                .el-checkbox__inner{
                    width: 1.33rem;height: 1.33rem;
                    &::after{
                        width: 0.3rem;height: 0.6rem;
                        top:0.1rem;left: 0.4rem;
                        border: 0.15rem solid #FFF;
                        border-left: 0;
                        border-top: 0;
                    }
                    &::before{
                        height: 0.25rem;
                        top: 0.45rem;
                    }
                }
                .el-checkbox__label{
                    font-family: PingFang-SC-Medium;
                    font-size: 1.1rem;
                    color: #333333;
                }
                .t{
                    height: 3rem;line-height: 3rem;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 0 1rem;
                    border-bottom: 1px solid #F0F0F0;
                    .label{
                        font-family: PingFang-SbtnC-Medium;
                        font-size: 1.1rem;
                        color: #333333;
                    }
                    .el-checkbox__label{
                        font-family: PingFang-SC-Medium;
                        font-size: 1rem;
                        color: #657085;
                    }
                    .btn{
                        padding: 0.5rem;
                        cursor: pointer;
                        font-family: PingFang-SC-Medium;
                        font-size: 1rem;
                        color: #657085;
                        span{
                            margin-left: 0.5rem;
                        }
                        i{
                            color: #A3AFBB;
                            font-size:0.8rem;
                        }
                    }
                }
                .b1,.b2{
                    height: calc(100% - 18rem);
                    border-bottom: 1px solid #F0F0F0;
                    position: relative;
                    .li{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        cursor: pointer;
                        padding-right: 1.2rem;
                        height: 2.5rem;line-height: 2.5rem;
                        .iconfont{
                            font-size:0.6rem;
                            color: #A0ACC2;
                            transition: all 0.5s;
                            transform:rotate(0deg);
                        }
                    }
                    .noShow .iconfont{
                        transform:rotate(180deg);
                    }
                    .bg_box{
                        position: absolute;
                        z-index: 0;
                        top: 0;left: 0;
                    }
                    .hotel_box{
                        margin-top: 1rem;
                        margin-left: 1.67rem;
                        // transition: all 1s;
                        overflow: hidden;
                        position: relative;
                        z-index: 1;
                        &.bg{
                            width: calc(100% - 1.67rem);
                            position: relative;
                            .build_box{
                                overflow: initial;
                                position: relative;
                                &.noShow{
                                    .floor_box{
                                        overflow: hidden;
                                    }
                                }
                                &:nth-child(3){
                                    >.bg{
                                        top: -1rem;
                                        width: 1rem;height: 2.3rem;
                                    }
                                }
                                .floor_box{
                                    overflow: initial;
                                    position: relative;
                                    &.noShow{
                                        .room_box{
                                            overflow: hidden;
                                        }
                                    }
                                    &:nth-child(3){
                                        >.bg{
                                            top: -1rem;
                                            width: 1rem;height: 2.3rem;
                                        }
                                    }
                                    .room_box{
                                        overflow: initial;
                                        position: relative;
                                        &:nth-child(3){
                                            >.bg{
                                                top: -1rem;
                                                width: 1rem;height: 2.3rem;
                                            }
                                        }
                                    }
                                }
                                .bg{
                                    position: absolute;
                                    top: -1.2rem;left: -1rem;
                                    width: 1rem;height: 2.5rem;
                                    border-left: 1px dashed #E1E5EA;
                                    border-bottom: 1px dashed #E1E5EA;
                                }
                                .bg_b{
                                    height: 100%;
                                    position: absolute;
                                    top: 0;left: -1rem;
                                    border-left: 1px dashed #E1E5EA;
                                }
                            }
                        }
                        &.noShow{
                            height: 2.5rem;
                        }
                        .build_box{
                            // margin-top: 0.5rem;
                            margin-left: 1.5rem;
                            overflow: hidden;
                            position: relative;
                            &.noShow{
                                height: 2.5rem;
                            }
                            .floor_box{
                                margin-left: 1.5rem;
                                overflow: hidden;
                                &.noShow{
                                    height: 2.5rem;
                                }
                                .room_box{
                                    margin-left: 1.5rem;
                                }
                            }
                        }
                    }
                }
                .b2{
                    height: 15rem;
                }
                .left{
                    width: 50%;
                    // flex: 1;
                    border-right: 1px solid #F0F0F0;
                }
                .right{
                    width: 50%;
                }
            }
        }
    }
</style>